<!--==========================
=            READ            =
===========================-->
<template>
  <!-- page blank -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Read</div>
      </base-header>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="12" md="12" d-flex>
        <base-card class="pa-2">
          <div slot="card-header">Read</div>
          <div slot="card-body">
            <div class="email-leftbar card">
              <button
                type="button"
                class="btn btn-danger btn-block waves-effect waves-light"
                data-toggle="modal"
                data-target="#composemodal"
              >Compose</button>
              <div class="mail-list mt-4">
                <a href="#" class="active">
                  <i class="mdi mdi-email-outline mr-2"></i> Inbox
                  <span class="ml-1 float-right">(18)</span>
                </a>
                <a href="#">
                  <i class="mdi mdi-star-outline mr-2"></i>Starred
                </a>
                <a href="#">
                  <i class="mdi mdi-diamond-stone mr-2"></i>Important
                </a>
                <a href="#">
                  <i class="mdi mdi-file-outline mr-2"></i>Draft
                </a>
                <a href="#">
                  <i class="mdi mdi-email-check-outline mr-2"></i>Sent Mail
                </a>
                <a href="#">
                  <i class="mdi mdi-trash-can-outline mr-2"></i>Trash
                </a>
              </div>
              <h6 class="mt-4">Labels</h6>
              <div class="mail-list mt-1">
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-info float-right"></span>Theme Support
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-warning float-right"></span>Freelance
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-primary float-right"></span>Social
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-danger float-right"></span>Friends
                </a>
                <a href="#">
                  <span class="mdi mdi-arrow-right-drop-circle text-success float-right"></span>Family
                </a>
              </div>
            </div>
            <!-- End Left sidebar -->
            <!-- Right Sidebar -->
            <div class="email-rightbar mb-3">
              <div class="card">
                <div class="btn-toolbar p-3" role="toolbar">
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button type="button" class="btn btn-primary waves-light waves-effect">
                      <i class="fa fa-inbox"></i>
                    </button>
                    <button type="button" class="btn btn-primary waves-light waves-effect">
                      <i class="fa fa-exclamation-circle"></i>
                    </button>
                    <button type="button" class="btn btn-primary waves-light waves-effect">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button
                      type="button"
                      class="btn btn-primary waves-light waves-effect dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-folder"></i>
                      <i class="mdi mdi-chevron-down ml-1"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#">Updates</a>
                      <a class="dropdown-item" href="#">Social</a>
                      <a class="dropdown-item" href="#">Team Manage</a>
                    </div>
                  </div>
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button
                      type="button"
                      class="btn btn-primary waves-light waves-effect dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-tag"></i>
                      <i class="mdi mdi-chevron-down ml-1"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#">Updates</a>
                      <a class="dropdown-item" href="#">Social</a>
                      <a class="dropdown-item" href="#">Team Manage</a>
                    </div>
                  </div>
                  <div class="btn-group mr-2 mb-2 mb-sm-0">
                    <button
                      type="button"
                      class="btn btn-primary waves-light waves-effect dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      More
                      <i class="mdi mdi-dots-vertical ml-2"></i>
                    </button>
                    <div class="dropdown-menu">
                      <a class="dropdown-item" href="#">Mark as Unread</a>
                      <a class="dropdown-item" href="#">Mark as Important</a>
                      <a class="dropdown-item" href="#">Add to Tasks</a>
                      <a class="dropdown-item" href="#">Add Star</a>
                      <a class="dropdown-item" href="#">Mute</a>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="media mb-4">
                    <img
                      class="d-flex mr-3 rounded-circle avatar-sm"
                      src="../../assets/img/users/2.jpg"
                      alt="Generic placeholder image"
                    />
                    <div class="media-body">
                      <h5 class="font-size-14 mt-1">Humberto D. Champion</h5>
                      <small class="text-muted">support@domain.com</small>
                    </div>
                  </div>
                  <h4 class="mt-0 font-size-16">This Week's Top Stories</h4>
                  <p>Dear Lorem Ipsum,</p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
                    tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
                    quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
                    consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
                    cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
                    proident, sunt in culpa qui officia deserunt mollit anim id est laborum..
                  </p>
                  <p>Sincerly,</p>
                  <hr />
                  <div class="row">
                    <div class="col-xl-2 col-6">
                      <div class="card">
                        <img
                          class="card-img-top img-fluid"
                          src="../../assets/img/small/img-3.jpg"
                          alt="Card image cap"
                        />
                        <div class="py-2 text-center">
                          <a href="#" class="font-weight-medium">Download</a>
                        </div>
                      </div>
                    </div>
                    <div class="col-xl-2 col-6">
                      <div class="card">
                        <img
                          class="card-img-top img-fluid"
                          src="../../assets/img/small/img-4.jpg"
                          alt="Card image cap"
                        />
                        <div class="py-2 text-center">
                          <a href="#" class="font-weight-medium">Download</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <a class="btn white--text btn-secondary waves-effect mt-4">
                    <i class="mdi mdi-reply"></i> Reply
                  </a>
                </div>
              </div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";

export default {
  components: {
    BaseCard,
    BaseHeader
  }
};
</script>

<style scoped>
.email-leftbar {
  width: 236px;
  float: left;
  padding: 20px;
  border-radius: 5px;
}

.email-rightbar {
  margin-left: 260px;
}

.chat-user-box p.user-title {
  color: #343a40;
  font-weight: 500;
}

.chat-user-box p {
  font-size: 12px;
}

@media (max-width: 767px) {
  .email-leftbar {
    float: none;
    width: 100%;
  }

  .email-rightbar {
    margin: 0;
  }
}

.mail-list a {
  display: block;
  color: #74788d;
  line-height: 24px;
  padding: 8px 5px;
}

.mail-list a.active {
  color: #f46a6a;
  font-weight: 500;
}

.message-list {
  display: block;
  padding-left: 0;
}

.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
}

.message-list li a {
  color: #74788d;
}

.message-list li:hover {
  background: #f6f6f6;
  -webkit-transition-duration: 0.05s;
  transition-duration: 0.05s;
}

.message-list li .col-mail {
  float: left;
  font-size: 12px !important;
  position: relative;
}

.message-list li .col-mail-1 {
  width: 320px;
}

.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot,
.message-list li .col-mail-1 .star-toggle {
  display: block;
  float: left;
}

.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}

.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}

.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}

.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 110px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}

.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}

.message-list li .col-mail-2 .date,
.message-list li .col-mail-2 .subject {
  position: absolute;
  top: 0;
}

.message-list li .col-mail-2 .subject {
  left: 0;
  right: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.message-list li .col-mail-2 .date {
  right: 0;
  width: 170px;
  padding-left: 80px;
}

.message-list li.active,
.message-list li.active:hover {
  -webkit-box-shadow: inset 3px 0 0 #556ee6;
  box-shadow: inset 3px 0 0 #556ee6;
}

.message-list li.unread {
  background-color: #f6f6f6;
  font-weight: 500;
  color: #292d32;
}

.message-list li.unread a {
  color: #292d32;
  font-weight: 500;
}

.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  -webkit-box-shadow: inset 0 0 0 1px #ced4da;
  box-shadow: inset 0 0 0 1px #ced4da;
  border-radius: 1px;
}

.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}

.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}

.message-list .checkbox-wrapper-mail label {
  position: absolute;
  height: 20px;
  width: 20px;
  left: 0;
  cursor: pointer;
  opacity: 0;
  margin-bottom: 0;
  -webkit-transition-duration: 0.05s;
  transition-duration: 0.05s;
  top: 0;
}

.message-list .checkbox-wrapper-mail label:before {
  content: "\F12C";
  font-family: "Material Design Icons";
  top: 0;
  height: 20px;
  color: #292d32;
  width: 20px;
  position: absolute;
  margin-top: -16px;
  left: 4px;
  font-size: 13px;
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 200px;
  }
}

.project-list-table {
  border-collapse: separate;
  border-spacing: 0 12px;
}

.project-list-table tr {
  background-color: #fff;
}

.contact-links a {
  color: #495057;
}

.profile-user-wid {
  margin-top: -26px;
}

.counter-number {
  font-size: 32px;
  font-weight: 600;
  text-align: center;
}

.counter-number span {
  font-size: 16px;
  font-weight: 400;
  display: block;
  padding-top: 5px;
}

.coming-box {
  float: left;
  width: 25%;
}

.hori-timeline .events .event-list {
  text-align: center;
  display: block;
}

.hori-timeline .events .event-list:hover .up-arrow-icon {
  -webkit-animation: fade-up 1.5s infinite linear;
  animation: fade-up 1.5s infinite linear;
}

@media (min-width: 1140px) {
  .hori-timeline .events .event-list {
    width: 24%;
    margin: 0;
    display: inline-block;
  }

  .hori-timeline .events .event-list .event-up-icon {
    position: relative;
  }

  .hori-timeline .events .event-list .event-up-icon::before {
    content: "";
    position: absolute;
    width: 100%;
    top: 16px;
    left: 0;
    right: 0;
    border-bottom: 3px dashed #f6f6f6;
  }

  .hori-timeline .events .event-list .event-up-icon .up-arrow-icon {
    position: relative;
    background-color: #fff;
    padding: 4px;
  }
}

.verti-timeline {
  border-left: 3px dashed #f6f6f6;
  margin: 0 10px;
}

.verti-timeline .event-list {
  position: relative;
  padding: 0 0 40px 30px;
}

.verti-timeline .event-list .event-timeline-dot {
  position: absolute;
  left: -9px;
  top: 0;
  z-index: 9;
  font-size: 16px;
}

.verti-timeline .event-list .event-content {
  position: relative;
  border: 2px solid #eff2f7;
  border-radius: 7px;
}

.verti-timeline .event-list.active .event-timeline-dot {
  color: #556ee6;
}

.verti-timeline .event-list:last-child {
  padding-bottom: 0;
}

.plan-box .plan-btn {
  position: relative;
}

.plan-box .plan-btn::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: #f6f6f6;
  left: 0;
  right: 0;
  top: 12px;
}
</style>
<!--====  End of READ  ====-->